module.exports = __webpack_public_path__ + "media/images/icon/arrow-circle-right-white-69ae454a2a8b2f3aa896bb589a7504e4.svg";